import { FileText, Image as ImageIcon, ExternalLink, Eye, EyeOff, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";

export const CATEGORIES = { esami: "Esami del sangue", referto: "Referto medico", documento: "Documento", altro: "Altro" };

const sizeLabel = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export async function openAttachment(att) {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(`/attachments/${att.id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (win) win.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (win) win.close();
    toast.error(errMsg(err));
  }
}

export function AttachmentList({ items, onToggle, onDelete, prefix = "attachment" }) {
  return (
    <div className="space-y-3">
      {items.map((a) => {
        const Icon = a.content_type === "application/pdf" ? FileText : ImageIcon;
        return (
          <div key={a.id} className="flex flex-wrap items-center gap-4 rounded-2xl border border-[#e2e8f0] bg-white p-4" data-testid={`${prefix}-item-${a.id}`}>
            <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#edf2ef] text-[#3d655b]"><Icon className="h-5 w-5" /></div>
            <div className="min-w-0 flex-1">
              <div className="truncate font-semibold">{a.title}</div>
              <div className="text-xs text-slate-500">
                {CATEGORIES[a.category] || a.category}{a.date ? ` · ${fmtDate(a.date)}` : ""} · {sizeLabel(a.size)}
              </div>
            </div>
            <div className="flex items-center gap-1">
              {onToggle && (
                <button onClick={() => onToggle(a)} data-testid={`${prefix}-toggle-${a.id}`}
                  className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold ${a.visible ? "bg-emerald-50 text-emerald-700" : "bg-orange-50 text-orange-700"}`}>
                  {a.visible ? <><Eye className="h-3.5 w-3.5" /> Visibile</> : <><EyeOff className="h-3.5 w-3.5" /> Nascosto</>}
                </button>
              )}
              <button className="btn-ghost text-[#3d655b]" onClick={() => openAttachment(a)} data-testid={`${prefix}-open-${a.id}`}><ExternalLink className="h-4 w-4" /> Apri</button>
              {onDelete && <button className="btn-ghost text-slate-400 hover:text-rose-600" onClick={() => onDelete(a)} data-testid={`${prefix}-delete-${a.id}`}><Trash2 className="h-4 w-4" /></button>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
